<template>
  <div class="general">
    <div class="section1">
      <div class="item1">
        <layout1 :title="dateType=='1'?'当月总用电':'当前年总用电'" style="padding-bottom: 23px;">
          <div class="box" style="    padding-top: 30px;">
            <div class="left vflex">
              <div class="top"> <count-to :start-val="0" :end-val="electData.todayUseElect" :duration="1000"
                  style="font-weight: bold;" class="card-panel-num" />
              </div>
              <div class="bottom" style="    padding-top: 70px;">
                {{dateType=='1'?'上月同期':'去年同期'}}：{{ electData.compareUseElect | getTwo}}kWh
              </div>
            </div>
            <div class="middle vflex">
              <div class="top">kWh</div>
              <div class="bottom" style="    padding-top: 60px;">
                <span>环比 </span>
                <!-- <img src="../../assets/images/icon/icon5.png" /> -->
                <span> {{ electData.tb*100 | getTwo}}%</span>
                <span v-if="electData.tb < 0" style="color: #33cc8d;font-size: 25px;"> ⬇ </span><span
                  v-if="electData.tb > 0" style="color: #fc5656;font-size: 25px;"> ⬆
                </span>
              </div>
            </div>

          </div>
        </layout1>


      </div>
      <div class="item2" style="padding-left: 10px;">
        <layout1 title="尖峰谷平" style="padding-bottom: 23px;width: 750px;">
          <div class="box" style="width: 700px;height: 350px;">

            <div class="top" style="width: 100%;height: 100%;">
              <v-chart :option="options2" ref="chart2"></v-chart>

            </div>

          </div>
        </layout1>
      </div>
    </div>

    <div class="section3">
      <div class="item1">
        <layout1 :title="'用电趋势'">

          <div class="box">
            <div class="left">

              <div class="bottom">
                <v-chart :option="options" ref="chart"></v-chart>
              </div>
            </div>

          </div>
        </layout1>
      </div>

    </div>
  </div>
</template>

<script>
  import layout1 from "../../layout/layout1";
  import CountTo from 'vue-count-to'
  import ECharts from "vue-echarts";
  export default {
    name: "yxnh",
    data () {
      return {
        electData: { todayUseElect: 0 },
        projectId: 0,
        allElectric: 0,

        options: {
          color: ['#5470C6', '#00CE7C60'],
          tooltip: {
            trigger: "axis",
            formatter: function (params) {
              let params1 = params[0];
              let params2 = params[1];
              return (
                params.length == 1 ? params1.marker + params1.seriesName + '<br/>' +
                  params1.axisValueLabel + (params1.value ? "" : "---") :
                  params2.marker + params2.seriesName + '<br/>' +
                  params2.axisValueLabel + (params2.value ? "" : "---") +
                  '<br/>' +
                  params1.marker + params1.seriesName + '<br/>' +
                  params1.axisValueLabel + (params1.value ? "" : "---") +
                  '<br/><br/>' +
                  params2.marker + params1.marker + "环比：" + ((params1.value - params2.value) / params2.value * 100).toFixed(2) + '%'


              );
            },
            axisPointer: {
              animation: false
            }

          },
          legend: {},
          grid: {
            top: 70,
            bottom: 50
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {
                alignWithLabel: true
              },
              axisLine: {
                onZero: false,
                lineStyle: {
                  color: '#5470C6'
                }
              },
              axisPointer: {
                label: {
                  formatter: function (params) {
                    return (
                      'Precipitation  ' +
                      params.value +
                      (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                    );
                  }
                }
              },
              // prettier-ignore
              data: []
            },
            {
              type: 'category',
              axisTick: {
                alignWithLabel: true
              },
              axisLine: {
                onZero: false,
                lineStyle: {
                  color: '#00CE7C'
                }
              },
              axisPointer: {
                label: {
                  formatter: function (params) {
                    return (
                      'Precipitation  ' +
                      params.value +
                      (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                    );
                  }
                }
              },
              // prettier-ignore
              data: []
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '当月用电',
              type: 'line',
              xAxisIndex: 0,
              smooth: true,
              emphasis: {
                focus: 'series'
              },
              data: [],
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: "rgba(20, 96, 224, 0.5)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(20, 96, 224, 0)", // 100% 处的颜色
                  },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            {
              name: '上月用电',
              type: 'line',
              smooth: true,
              xAxisIndex: 1,
              emphasis: {
                focus: 'series'
              },
              data: [],
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: "rgba(0, 206, 124, 0.3)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 206, 124, 0)", // 100% 处的颜色
                  },
                  ],
                  global: false, // 缺省为 false
                },
              }
            }
          ]
        },
        options2: {

          legend: {
            textStyle: {
              fontSize: 15
            },
            left: 'center',
            top: "bottom"
          },
          series: [
            {
              name: 'Access From',
              type: 'pie',
              radius: ['0%', '50%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                alignTo: 'edge',
                formatter: '{name|{c}}, 占{d}%\n{time|{b} kWh}',
                minMargin: 5,
                edgeDistance: 50,
                lineHeight: 35,
                rich: {
                  time: {
                    fontSize: 15,
                    color: '#999'
                  }
                },
                textStyle: {
                  fontSize: 15
                },
              },
              labelLayout: function (params) {
                const isLeft = params.labelRect.x < 350;
                const points = params.labelLinePoints;
                points[2][0] = isLeft
                  ? params.labelRect.x
                  : params.labelRect.x + params.labelRect.width;
                return {
                  labelLinePoints: points
                };
              },
              labelLine: {
                length: 15,
                length2: 0,
                maxSurfaceAngle: 80
              },
              data: [
                { value: 0, name: '尖电量' },
                { value: 0, name: '峰电量' },
                { value: 0, name: '谷电量' },
                { value: 0, name: '平电量' }
              ]
            }
          ]
        },
      };
    },
    props: {
      date: {
        type: String
      },
      dateType: {
        type: String
      },
    },
    components: { layout1, "v-chart": ECharts, CountTo },
    created () {
      this.projectId = this.$getCookie("projectId");

      this.searchPeak();
    },
    mounted () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
      searchProjectElect (type, dateType) {
        this.todayEleLoading = true;
        let strs = this.date.split("-")
        let str
        if (dateType == 1) {
          str = strs[0] + "-" + strs[1]
        } else {
          str = strs[0]
        }

        this.$http
          .post("bma-distribution-service/monthReport/searchProjectElect", {
            date: str,
            dateType: dateType,
            projectId: this.projectId,
            dataType: "1",
          })
          .then((res) => {
            if (dateType == "1") {
              this.options.series[0].name = "当月用电"
              this.options.series[1].name = "上月用电"
            } else {
              this.options.series[0].name = "当前年用电"
              this.options.series[1].name = "去年用电"
            }




            if (type == 0 || type == 1) {
              // 用电概况
              this.electData = res.data;
              this.todayEleLoading = false;

            }
            if (type == 1 || type == 2) {

              // 用电趋势
              let useElectrics = res.data.useElectrics;
              let compareUseElectrics = res.data.compareUseElectrics;
              // x轴
              let iFlag = 0;
              let xAxis = [];
              let xAxis2 = [];
              // 截至时间
              let newFlag = 0;
              let ii = 0;
              if (dateType == 1) {
                ii = 1;
                iFlag = 31;
                for (let i = 1; i <= (res.data.compareUseElectricsMonthDays); i++) {
                  xAxis2.push(res.data.compareUseElectricsMonth + "-" + i + "日");
                }
                for (let i = 1; i <= (31 - res.data.compareUseElectricsMonthDays + 1); i++) {
                  xAxis2.push("-")
                }

                for (let i = 1; i <= (res.data.useElectricsMonthDays); i++) {
                  xAxis.push(res.data.useElectricsMonth + "-" + i + "日");
                }
                for (let i = 1; i <= (31 - res.data.useElectricsMonthDays + 1); i++) {
                  xAxis.push("-")
                }
                newFlag = new Date().getDate();
              } else if (dateType == 2) {
                ii = 1;
                iFlag = 12;
                for (let i = 1; i <= 12; i++) {
                  xAxis.push(i + "月");
                }
                newFlag = new Date().getMonth() + 1;
              } else if (dateType == 3) {
                ii = 1;
                iFlag = 6;
                for (let i = 1; i <= 6; i++) {
                  xAxis.push(i + "月");
                }
                newFlag = new Date().getMonth() + 1;
              } else if (dateType == 4) {
                ii = 7;
                iFlag = 12;
                for (let i = 7; i <= 12; i++) {
                  xAxis.push(i + "月");
                }
                newFlag = new Date().getMonth() + 1;
              }

              // 已有的时间list
              let dateList1 = [];
              let dateList2 = [];
              // 数据list
              let data1 = [];
              let data2 = [];
              // 求最大电量和用电时间
              let maxElect = 0;
              let maxElectDate = "";
              if (useElectrics) {
                useElectrics.forEach((item) => {
                  dateList1.push(item.date);
                  if (Number(item.electric) > maxElect) {
                    maxElect = Number(item.electric);
                    maxElectDate = item.date;
                  }
                });
              }
              if (compareUseElectrics) {
                compareUseElectrics.forEach((item) => {
                  dateList2.push(item.date);
                });
              }
              for (let i = ii; i <= iFlag; i++) {
                let index1 = dateList1.indexOf(i);
                if (index1 > -1) {
                  data1.push(this.$genderMenu(useElectrics[index1].electric));
                } else if (index1 == -1 && i <= newFlag) {
                  data1.push(0);
                } else {
                  data1.push("");
                }

                let index2 = dateList2.indexOf(i);
                if (index2 > -1) {
                  data2.push(
                    this.$genderMenu(compareUseElectrics[index2].electric)
                  );
                } else {
                  data2.push('');
                }
              }
              this.options.xAxis[0].data = xAxis;
              this.options.xAxis[1].data = xAxis2;

              this.options.xAxis[0].axisPointer.label.formatter = function (params) {
                return (
                  res.data.useElectricsYear + "-" +
                  params.value +
                  (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                );
              }
              this.options.xAxis[1].axisPointer.label.formatter = function (params) {
                return (
                  res.data.compareUseElectricsYear + "-" +
                  params.value +
                  (params.seriesData.length ? '：' + params.seriesData[0].data : '')
                );
              }

              this.$refs.chart.setOption(this.options, true);
              this.maxElect = maxElect;

              this.options.series[0].data = data1
              this.options.series[1].data = data2
              this.maxElectDate = maxElectDate;


            }
          });
      },
      searchPeak () {
        this.todayEleLoading = true;
        let strs = this.date.split("-")
        let str = strs[0] + "-" + strs[1]
        this.$http
          .post("bma-distribution-service/monthReport/searchPeak", {
            date: str,
            projectId: this.projectId,
            dateType: this.dateType
          })
          .then((res) => {
            if (res.data.jian == 0) {
              this.options2.series[0].data = [
                { value: res.data.feng, name: '峰电量' },
                { value: res.data.gu, name: '谷电量' },
                { value: res.data.ping, name: '平电量' }
              ]

            } else {
              this.options2.series[0].data = [
                { value: res.data.jian, name: '尖电量' },
                { value: res.data.feng, name: '峰电量' },
                { value: res.data.gu, name: '谷电量' },
                { value: res.data.ping, name: '平电量' }
              ]
            }


            this.$refs.chart2.setOption(this.options2, true);
            this.searchProjectElect(1, this.dateType);
          });
      },
    },
  };
</script>

<style lang="less" scoped>
  .general {
    // padding: 15px 0px 15px 15px;
    width: calc(100% - 30px);
    height: 100%;
    padding: 15px; // width: calc(100% - 20px);

    // height: 100%;
    .change-date {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 140px;
      color: rgba(113, 119, 137, 1);
      font-size: 14px;
      display: flex;
      justify-content: space-between;

      p {
        width: 25px;
        text-align: center;
        cursor: pointer;
        padding-bottom: 6px;

        &.active {
          color: rgba(20, 96, 224, 1);
          border-bottom: 3px solid rgba(20, 96, 224, 1);
        }
      }
    }

    .section1 {
      display: flex;


      .item1 {
        // width: 596px;
        // height: 204px;
        width: 480px;
        //height: 100%;
        position: relative;

        .box {
          display: flex;
          margin-top: 20px;

          .vflex {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 105px;
            width: 150px;
          }

          .left {
            width: 300px; // width: 280px;

            .top {
              font-size: 40px;
              font-weight: 600;
              line-height: 68px;
              color: #1e60cf;
              letter-spacing: 1px;
            }

            .bottom {
              font-size: 14px;
              color: #132742;
            }
          }

          .middle {
            text-align: right;
            padding-right: 30px;
            box-sizing: border-box;

            .top {
              font-size: 23px;
              color: #132742;
              line-height: 70px;
            }

            .bottom {
              font-size: 14px;
              color: #5a8fe8;

              img {
                width: 14px;
                height: 14px;
                position: relative;
                top: 2px;
                margin-left: 10px;
                margin-right: 2px;
              }
            }
          }

          .br {
            width: 1px;
            height: 105px;
            background: rgba(233, 233, 233, 1);
            margin-left: 10px;
            margin-right: 10px;
          }

          .right {
            align-content: center;
            padding-left: 30px;
            box-sizing: border-box;

            img {
              width: 30px;
              height: 30px;
            }

            .top {
              font-size: 15px;
              color: #181d33;
            }

            .bottom {
              font-size: 23px;
              color: #5a8fe8;
            }
          }
        }
      }

      .item2 {
        // width: 422px;
        width: 26%;
        height: 462px; // height: 100%;

        // width: 29%;
        .box {
          display: flex;
          flex-wrap: wrap; // padding-top: 8px;

          box-sizing: border-box; // height: 60%;
          width: 300px;

          .item {
            width: 300px;
            height: 113px;
            margin-right: 10px;
            margin-bottom: 14px;
            border: 1px solid #eceef5;
            border-radius: 4px;
            box-sizing: border-box;
            padding: 14px 16px;

            .title {
              display: flex;
              align-items: center;
              letter-spacing: 1px;

              img {
                width: 28px;
                height: 28px;
                margin-right: 10px;
              }

              p {
                font-size: 14px;
                color: rgba(14, 34, 61, 1);
              }
            }

            .bottom {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 20px;

              .left {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: 20px;
                height: 18px;

                p {
                  width: 100%;
                  height: 1px;
                  background: rgba(211, 213, 223, 1);
                }
              }

              .right {
                span {
                  &:first-of-type {
                    font-size: 18px;
                    display: inline-block;
                    cursor: pointer;
                    width: auto;
                    max-width: 80px;
                    color: rgba(19, 38, 64, 1);
                  }

                  &:last-of-type {
                    font-size: 12px;
                    color: #0e223d;
                  }
                }
              }
            }
          }
        }
      }
    }

    .section3 {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;

      .item1 {
        width: 100%; // width: 1210px;
        height: 462px; // height: 100%;
        // width: 70%;
        position: relative;

        .box {
          padding-top: 32px;
          display: flex;
          justify-content: space-between;
          padding-right: 15px;
          box-sizing: border-box;
          height: 400px;

          .left {
            // width: 800px;
            width: 100%;

            .top {
              display: flex;

              .info {
                width: auto;
                height: 41px;
                border: 1px solid #eaedef;
                border-radius: 21px;
                text-align: center;
                padding: 0px 10px;

                &:first-of-type {
                  margin-right: 33px;
                }

                &:nth-of-type(2) {
                  margin-right: 100px;
                }

                span {
                  line-height: 41px;
                  font-size: 14px;
                  font-weight: 600;

                  &:first-of-type {
                    color: rgba(14, 34, 61, 1);
                  }

                  &:last-of-type {
                    color: rgba(20, 96, 224, 1);
                  }
                }
              }

              .legend {
                display: flex;
                align-items: center;

                .color {
                  width: 12px;
                  height: 12px;
                  background: rgba(20, 96, 224, 1);
                  margin-right: 10px;

                  &.color2 {
                    background: rgba(0, 206, 124, 1);
                  }
                }

                p {
                  // font-size: 14px;
                  font-size: 15px;
                  color: rgba(33, 46, 67, 1);
                }
              }
            }

            .bottom {
              width: 100%; // height: 320px;
              height: 100%;
              border-right: 1px solid rgba(238, 238, 239, 1);
              padding-right: 12px;

              .echarts {
                width: 100%;
                height: 100%;
              }
            }
          }

          .right {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 40px;

            .top {
              width: 235px;
              height: 235px;
              border-radius: 50%;
              background: #fff;
              position: relative;
              box-shadow: 0px 0px 15px rgba(43, 62, 177, 0.07);

              .echarts {
                width: 100%;
                height: 100%;
              }

              .info {
                width: 140px;
                height: 140px;
                background: #f8f8f9;
                border-radius: 50%;
                position: absolute;
                box-shadow: 0px 0px 15px rgba(43, 62, 177, 0.07);
                top: 48px;
                left: 48px;
                text-align: center;

                .value {
                  font-size: 20px;
                  font-weight: 600;
                  line-height: 50px;
                  color: #333;
                  margin-top: 20px;
                }

                .label {
                  font-size: 14px;
                  color: rgba(68, 90, 90, 0.8);
                  line-height: 30px;
                }

                .unit {
                  font-size: 14px;
                  color: rgba(68, 90, 90, 0.8);
                }
              }
            }

            .bottom {
              margin-top: 53px;
              width: 340px;
              display: flex;
              justify-content: space-between;

              .label {
                display: flex;
                align-items: center;

                .color {
                  width: 12px;
                  height: 12px;
                  margin-right: 5px;
                }

                .name {
                  // font-size: 14px;
                  font-size: 15px;
                  color: #212e43;
                }
              }
            }
          }
        }
      }


    }
  }
</style>